import {
    MF_PAGE_LINK_ABOUT_US,
    MF_PAGE_LINK_CONTACT,
    MF_PAGE_LINK_COOKIES_POLICY,
    MF_PAGE_LINK_DISCLAIMER,
    MF_PAGE_LINK_ACCESSIBILITY,
    MF_PAGE_LINK_PRIVACY_POLICY,
    MF_PAGE_LINK_TERMS_OF_USE,
    MF_PAGE_LINK_TITLE_LINARES,
    MF_PAGE_LINK_TITLE_SERVICES,
    FOOTER_BRAND_TAGLINE,
    FOOTER_BRAND_BLURB,
    FOOTER_TITLE_COMPANY,
    FOOTER_TITLE_LEGAL,
    FOOTER_TITLE_CONTACT,
    FOOTER_TITLE_FOLLOW,
    FOOTER_LINK_SUPPORT,
    FOOTER_HOURS_LABEL,
    FOOTER_HOURS_WEEKDAYS,
    FOOTER_HOURS_SATURDAY,
    FOOTER_HOURS_SUNDAY,
    FOOTER_RIGHTS_RESERVED,
    FOOTER_MADE_WITH,
} from "../types";


const enMainFooter = {
    [MF_PAGE_LINK_TITLE_LINARES]: "Linares",
    [MF_PAGE_LINK_TITLE_SERVICES]: "Services",
    [MF_PAGE_LINK_ABOUT_US]: "About Us",
    [MF_PAGE_LINK_CONTACT]: "Contact Us",
    [MF_PAGE_LINK_TERMS_OF_USE]: "Terms & Conditions",
    [MF_PAGE_LINK_PRIVACY_POLICY]: "Privacy Policy",
    [MF_PAGE_LINK_DISCLAIMER]: "Disclaimer",
    [MF_PAGE_LINK_COOKIES_POLICY]: "Cookies Policy",
    [MF_PAGE_LINK_ACCESSIBILITY]: "Accessibility",
    [FOOTER_BRAND_TAGLINE]: "Bilingual professionals for your family",
    [FOOTER_BRAND_BLURB]: "From credit and taxes to immigration and travel — we handle the paperwork so you can focus on what matters.",
    [FOOTER_TITLE_COMPANY]: "Company",
    [FOOTER_TITLE_LEGAL]: "Legal",
    [FOOTER_TITLE_CONTACT]: "Get in touch",
    [FOOTER_TITLE_FOLLOW]: "Follow us",
    [FOOTER_LINK_SUPPORT]: "Support",
    [FOOTER_HOURS_LABEL]: "Office hours",
    [FOOTER_HOURS_WEEKDAYS]: "Mon – Thu · 6:00 PM – 10:00 PM",
    [FOOTER_HOURS_SATURDAY]: "Saturday · 10:00 AM – 5:00 PM",
    [FOOTER_HOURS_SUNDAY]: "Fri & Sun · Closed",
    [FOOTER_RIGHTS_RESERVED]: "All rights reserved.",
    [FOOTER_MADE_WITH]: "Proudly serving the Miami Lakes community.",
}


export default enMainFooter;

